/**
 * RM（アプリ内アンケート）の varuna エンドポイント クライアント。
 *
 * - `logRmDisplay/`   … ポップアップを開いたとき（rm_display_history）
 * - `submitRmAnswer/` … 回答したとき（rm_answer_history）
 *
 * 新規エンドポイントなので JSON で送る（careerconnection-client.ts と同じ作法）。
 */
import axios from 'axios'
import type { RmSurveySubmitBody } from '@/validation/rmSurveyAnswer'

const ENDPOINT_PREFIX = process.env.VUE_APP_ENDPOINT_PREFIX || '/'
const TIMEOUT_MS = 15000

const postJson = <T>(path: string, body: unknown) =>
  axios.post<T>(`${ENDPOINT_PREFIX}${path}`, body, {
    timeout: TIMEOUT_MS,
    headers: { 'Content-Type': 'application/json' }
  })

interface RmDisplayLogBody {
  uuid: string
  rm_condition_id: number
  rt_condition_id: number | null
  format_id: string
  device_flag: 'SP' | 'PC'
  app_flag: string
  site_flag: string
}

interface RmResultResponse {
  result?: string
  rm_display_history_id?: number
  error?: string
}

/** 表示履歴を残し、回答と紐づけるための rm_display_history_id を返す。失敗時は null */
export async function postRmDisplayLog(
  body: RmDisplayLogBody
): Promise<number | null> {
  const res = await postJson<RmResultResponse>('logRmDisplay/', body)
  const id = res.data?.rm_display_history_id
  return typeof id === 'number' ? id : null
}

export async function postRmAnswer(body: RmSurveySubmitBody): Promise<boolean> {
  const res = await postJson<RmResultResponse>('submitRmAnswer/', body)
  return res.data?.result === 'ok'
}
